/**
 * * More transports modal [find transport page]
 */
import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { getAdditionalTransportsError } from 'Store/booking/booking.selector';
import { t } from 'Src/i18n';
import { useAppContext } from 'Context/ReactAppContext';
import { AdditionalTransportLayer } from 'Components/widgets/additional-transports/AdditionalTransportLayer';
import { BookingEngineTrackingContext } from 'Views/booking/BookingEngineTrackingContext';
import { TrackPage } from 'Tracking/track-page/TrackPage';
import { TRACK_PAGE_NAMES } from 'Tracking/constants';
import { getTransportSearchCriteria } from 'Store/booking/proposals/proposals.action';
import { fetchAdditionalTransports } from 'Store/booking/additional-transports/additionalTransports.action';
import { makeViewProps, queryParamAsString } from 'Src/types/view-helpers';
type Props = {
  proposal: Proposal;
  onClose: (arg0: any, arg1: any) => void;
  setSelectedTransport?: (transportId: string) => void;
};
export const MoreTransports = ({
  proposal,
  onClose,
  setSelectedTransport = (transportId) => onClose(true, transportId),
}: Props) => {
  const beEngineTrackingContext = useContext(BookingEngineTrackingContext);
  const appContext = useAppContext();
  const error = useSelector(getAdditionalTransportsError);
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    query: { departure_city: departureCity },
  } = router;
  useEffect(() => {
    if (proposal.transports) {
      const transportSearchCriteria = getTransportSearchCriteria({
        proposal,
        departureCity: queryParamAsString(departureCity),
      });
      dispatch(
        fetchAdditionalTransports({
          proposal,
          transportSearchCriteria,
          appContext,
        }),
      );
    }
  }, [proposal.id]);
  const errorTitle = error
    ? t('booking.transport.additionalTransports.unknownErrorHeaderTitle')
    : undefined;
  return (
    <React.Fragment>
      <TrackPage
        pageName={TRACK_PAGE_NAMES.BE_LAYER_TRANSPORT}
        payload={makeViewProps<any>({ ...beEngineTrackingContext })}
      />
      <AdditionalTransportLayer
        onClose={(proposalId) => onClose(false, proposalId)}
        setSelectedTransport={setSelectedTransport}
        proposal={proposal}
        errorTitle={errorTitle}
      />
    </React.Fragment>
  );
};
